import { SecurityHelper } from '../helpers.js';

// Schema:
//   {
//     type: 'gallery',
//     layout: 'grid-4' | 'list',
//     images: [{ src, alt?, href? }]
//   }
export function renderGallery(block) {
  const images = Array.isArray(block.images) ? block.images : [];
  const layout = block.layout === 'list' ? 'list' : 'grid-4';

  const wrapper = document.createElement('div');
  wrapper.className = `cyx-block cyx-block-gallery cyx-block-gallery--${layout}`;

  for (const img of images) {
    if (!img || typeof img !== 'object') continue;
    const safeSrc = SecurityHelper.sanitizeURL(img.src || '');
    if (!safeSrc) continue;

    const cell = document.createElement('div');
    cell.className = 'cyx-block-gallery-cell';

    const imageEl = document.createElement('img');
    imageEl.src = safeSrc;
    imageEl.alt = String(img.alt || '');
    imageEl.loading = 'lazy';
    imageEl.className = 'cyx-block-gallery-img';

    const safeHref = SecurityHelper.sanitizeURL(img.href || '');
    if (safeHref) {
      const a = document.createElement('a');
      a.href = safeHref;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.appendChild(imageEl);
      cell.appendChild(a);
    } else {
      cell.appendChild(imageEl);
    }

    wrapper.appendChild(cell);
  }

  if (!wrapper.children.length) return null;
  return wrapper;
}
